function collapseItem(theme, ownerState) {
  const { palette } = theme;
  const { active } = ownerState;
  const { text, transparent } = palette;

  return {
    background: transparent.main,
    color: active ? "#226E90" : text.main,
    display: "flex",
    alignItems: "center",
    width: "100%",
    cursor: "pointer",
    userSelect: "none",
    whiteSpace: "nowrap",
  };
}

function collapseIconBox(theme, ownerState) {
  const { transitions, breakpoints } = theme;
  const { active } = ownerState;

  return {
    background: "transparent", // Bỏ màu nền của box
    minWidth: "auto", // Bỏ kích thước cố định để icon hiển thị tự nhiên
    minHeight: "auto",
    display: "flex", // Đổi sang flex để icon căn giữa mà không cần box
    alignItems: "center",
    justifyContent: "center",
    transition: transitions.create("margin", {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.standard,
    }),

    [breakpoints.up("xl")]: {
      background: "transparent", // Đảm bảo không có màu nền ở mọi breakpoint
    },

    "& svg, svg g, & img": {
      fill: "#FFFFFF", // Giữ màu trắng cho icon ở mọi trạng thái
      filter: active ? "drop-shadow(0px 0px 2px rgba(255, 255, 255, 0.8))" : "none", // Thêm bóng trắng khi active
    },
  };
}

function collapseText(theme, ownerState) {
  const { typography, transitions, breakpoints, functions } = theme;
  const { miniSidenav, transparentSidenav, active } = ownerState;

  const { size } = typography;
  const { pxToRem } = functions;

  return {
    marginLeft: pxToRem(12.8),
    whiteSpace: "normal",
    wordWrap: "break-word",
    overflow: "hidden",
    maxHeight: pxToRem(58),

    [breakpoints.up("xl")]: {
      opacity: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : 1,
      maxWidth: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : "100%",
      marginLeft: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : pxToRem(12.8),
      transition: transitions.create(["opacity", "margin"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
    },

    "& span": {
      fontWeight: active ? "700" : "500", // Font-weight: 500 (mặc định), 700 (active)
      fontSize: size.sm,
      lineHeight: 1.5,
      color: "#3c7363",
    },
  };
}

export { collapseItem, collapseIconBox, collapseText };
